/**
 * Design provider selector — one interface, multiple designers. The offline
 * mock is the default so the app never breaks without a key. The live
 * providers (OpenAI, Claude, Gemini) all route through the same backend
 * proxy via the remote provider; only the `provider` field differs.
 *
 * Choose the live provider with REACT_APP_AI_GENERATOR_PROVIDER
 * (openai | claude | gemini), or override per call.
 */

import { mockGenerateDesigns } from './mockDesignProvider';
import { makeProvider } from './remoteDesignProvider';

export const PROVIDERS = {
  mock: mockGenerateDesigns,
  openai: makeProvider('openai'),
  claude: makeProvider('claude'),
  gemini: makeProvider('gemini'),
};

export const PROVIDER_NAMES = Object.keys(PROVIDERS);

export const activeProviderName = () => {
  const configured = process.env.REACT_APP_AI_GENERATOR_PROVIDER;
  return PROVIDERS[configured] ? configured : 'mock';
};

/**
 * Resolve the generate function. `override` (a provider name) wins over env,
 * so tests and callers can force a provider. Falls back to the mock.
 */
export const getDesignProvider = (override) =>
  PROVIDERS[override] || PROVIDERS[activeProviderName()] || mockGenerateDesigns;
